import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/node/CircularProgress/index.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/public/peters-logo.png");
import(/* webpackMode: "eager" */ "/app/src/app/styles.module.scss")